import { ApexOptions } from 'apexcharts';
import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import Card, { CardProps } from '@mui/material/Card';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import InfoIcon from '@mui/icons-material/Info';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Iconify from 'src/components/iconify';
import Chart, { useChart } from 'src/components/chart';
// ----------------------------------------------------------------------

export interface ChartData {
  categories?: number[];
  series: {
    name: string;
    data: number[];
  }[];
}

interface Props extends CardProps {
  title?: string;
  subheader?: string;
  chart: ChartData; // Adjusted for correct typing
  options?: ApexOptions;
}

export default function EcommerceSavingSales({ title, subheader, chart, ...other }: Props) {
  const { categories, series } = chart;

  const chartOptions = useChart({
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    yaxis: {
      labels: {
        formatter: (value: string | number) => {
          // Ensure we are dealing with a number before we format it
          if (typeof value === 'number') {
            const val = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
            }).format(value);
            return ` ${val} M`;
          }
          return value;
        },
      },
    },
    xaxis: {
      categories,
    },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter :(value: string | number) => {

          // Ensure we are dealing with a number before we format it
          if (typeof value === 'number') {
            const val= new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
            }).format(value);
            return ` ${val}M`
          }
          return value;
        },
        title: {
          formatter: (seriesName: string) => `${seriesName}`,
        },
      },
    },
  });

  return (
    <>
      <Card {...other}>
        <CardHeader
          title={title}
          subheader='(in Millions USD)'
          // style={{ display: 'flex' }}
          // action={<InfoIcon color="action" style={{ paddingLeft: '5px', color: '#4040ab' }} />}
        />
        <Box key={title} sx={{ mt: 3, mx: 3 }}>
          <Chart
            dir="ltr"
            type="area"
            series={series}
            options={chartOptions}
            width="100%"
            height={270}
          />
        </Box>
      </Card>
    </>
  );
}
